var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dropdown",
    {
      staticClass: "dropdown",
      attrs: { trigger: "click" },
      on: { "visible-change": _vm.visibleChange }
    },
    [
      _vm._t("trigger"),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        _vm._l(_vm.menuOptions, function(item) {
          return _c(
            "el-dropdown-item",
            { key: item.key, staticClass: "custom-dropdown-item" },
            [
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleSelect(item.key)
                    }
                  }
                },
                [_vm._v(_vm._s(item.label))]
              )
            ]
          )
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }